module.exports = __webpack_public_path__ + "img/anton.7b321a21.png";